import React, { useState } from 'react';
import { adminLogin } from '../services/apiService';

const AdminLogin = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const result = await adminLogin(email, password);

      if (result.success) {
        setEmail('');
        setPassword('');
        onLoginSuccess();
      } else {
        setError(result.message || '登录失败，请检查邮箱和密码');
      }
    } catch (error) {
      console.error('Admin login error:', error);
      setError('网络错误，请稍后重试');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#191c17] to-[#0a0c0a] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo 区域 */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">Metalbox</h1>
          <p className="text-[#f5a623] font-semibold">管理后台</p>
        </div>

        {/* 登录卡片 */}
        <div className="bg-[#1a1d17] border border-[#4a5f3a] rounded-xl p-8 shadow-2xl">
          {/* 标题 */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-white mb-2">管理员登录</h2>
            <p className="text-gray-400 text-sm">请输入管理员邮箱和密码</p>
          </div>

          {/* 错误提示 */}
          {error && (
            <div className="mb-6 p-4 bg-red-500/20 border border-red-500/50 rounded-lg flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#ef4444"
                viewBox="0 0 256 256"
              >
                <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-56h16a8,8,0,0,0,8-8V88a8,8,0,0,0-16,0v56A8,8,0,0,0,120,160Zm12-36a12,12,0,1,1-12-12A12,12,0,0,1,132,124Z"></path>
              </svg>
              <span className="text-red-300 text-sm">{error}</span>
            </div>
          )}

          {/* 登录表单 */}
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* 隐藏的邮箱字段 - 用于浏览器自动填充凭证 */}
            <input
              type="email"
              name="email"
              value={email}
              style={{ display: 'none' }}
              readOnly
            />

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-white mb-2">
                邮箱地址
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入邮箱地址"
                className="w-full px-4 py-3 rounded-lg bg-[#262a22] border-2 border-[#4b5445] text-white placeholder-gray-500 focus:outline-none focus:border-[#5a6f4a] transition-colors"
                required
                disabled={isLoading}
                autoComplete="email"
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-white mb-2">
                密码
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="请输入您的密码"
                  className="w-full px-4 py-3 pr-12 rounded-lg bg-[#262a22] border-2 border-[#4b5445] text-white placeholder-gray-500 focus:outline-none focus:border-[#5a6f4a] transition-colors"
                  required
                  disabled={isLoading}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors disabled:opacity-50"
                  disabled={isLoading}
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 256 256"
                    >
                      <path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C190.29,52.41,153.53,37,128,37s-62.29,15.41-91.66,49.35C17.51,105.18,9.05,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C65.71,203.59,102.47,219,128,219s62.29-15.41,91.66-49.35c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,191a63,63,0,1,1,63-63A63.07,63.07,0,0,1,128,191Zm0-112a49,49,0,1,0,49,49A49.06,49.06,0,0,0,128,79Z"></path>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 256 256"
                    >
                      <path d="M53.92,34.62A8,8,0,1,0,42.08,45.46l44,50.91a88.4,88.4,0,0,0-20.08,29.54H40a8,8,0,0,0,0,16h27.35A127.6,127.6,0,0,1,128,40c23.12,0,45.62,7.2,66.35,20.46l23.59,27.31a8,8,0,0,0,6.14,3,7.86,7.86,0,0,0,5.11-1.71,8,8,0,0,0-5.11-14.12L196.56,48a111.33,111.33,0,0,0-28.92-10.31l12.67-14.64a8,8,0,1,0-12.3-10.38Zm50,116.13A47.89,47.89,0,0,1,128,145a48,48,0,0,1,32,84,48.4,48.4,0,0,1-8.35.72A47.88,47.88,0,0,1,103.92,150.75ZM216,128a8,8,0,0,1-8,8H180.65a127.6,127.6,0,0,1-115.35,64H40a8,8,0,0,1,0-16h27.35A111.45,111.45,0,0,0,128,179.9,112,112,0,0,0,180.65,124H208A8,8,0,0,1,216,128Z"></path>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* 提交按钮 */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-[#4a5f3a] hover:bg-[#5a7f4a] disabled:bg-[#4a5f3a]/50 disabled:cursor-not-allowed text-white px-6 py-3 rounded-lg font-medium transition-colors mt-6"
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  登录中...
                </span>
              ) : (
                '登 录'
              )}
            </button>
          </form>

          {/* 提示信息 */}
          <div className="mt-6 pt-6 border-t border-[#2a2d27]">
            <p className="text-center text-gray-400 text-xs">
              🔒 仅管理员可访问此页面
            </p>
            <p className="text-center text-gray-500 text-xs mt-2">
              默认账户: admin@metalboxmodels.com
            </p>
          </div>
        </div>

        {/* 底部版本信息 */}
        <div className="text-center mt-8">
          <p className="text-gray-500 text-xs">Metalbox 管理后台 v1.0.0</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
